// @flow
import JQueryView, { on } from '../common/JQueryView';

declare var $: any;

export default class InvestorContactView extends JQueryView {
  constructor() {
    super('.investor_contact');
  }

  @on('click #scroll-button')
  onClickScrollButton(e: any) {
    e.preventDefault();
    const offset = $('#lp-form').offset()?.top;

    if (offset !== undefined) {
      $('html, body').animate({ scrollTop: offset }, 600);
    }
  }
}
